import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = window.location.origin;

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/auth/login`, {
        email,
        password
      });

      // Store admin token
      localStorage.setItem('admin_token', response.data.token);
      localStorage.setItem('admin_user', JSON.stringify(response.data.admin));

      toast.success('Welcome back, Super Admin!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-600 via-red-700 to-red-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center pb-4">
          <div className="mx-auto mb-4">
            <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center">
              <span className="text-3xl font-bold text-white">W</span>
            </div>
          </div>
          <CardTitle className="text-2xl font-bold">WaiterMan Master Admin</CardTitle>
          <p className="text-gray-600 text-sm mt-2">Central management panel for all restaurants</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="email">Email Address</Label>
              <Input
                id="email"
                type="email"
                placeholder="admin@waiterman.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-red-600 hover:bg-red-700"
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login as Super Admin'}
            </Button>
            
            {/* Forgot Password Link */}
            <div className="mt-4 text-center">
              <button
                type="button"
                onClick={() => navigate('/admin/forgot-password')}
                className="text-sm text-red-600 hover:text-red-800 font-medium"
              >
                Forgot Password?
              </button>
            </div>
          </form>
          
          <div className="mt-6 pt-6 border-t text-center text-sm text-gray-600">
            <p>Regular restaurant login? <a href="/login" className="text-red-600 hover:underline">Click here</a></p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
